<template>
    <div>
        <!-- BradCrumb header Start-->
        <section class="inner-header-bg">
            <div class="container">
                <div class="section-breadcrumb">
                    <div class="container">
                        <div class="row">
                            <div class="col-md-12 justify-content-center align-self-center pb-2">
                                <div class="breadcrumb-content">
                                    <div class="title-section">
                                        <h1 class="title text-center text-white">Protecting the Network That Runs Your Operation</h1>
                                    </div>
                                    <div class="breadcrumb-nav">
                                        <ul class="breadcrumb-link text-center list-unstyled mb-0">
                                            <li class="text-white"><router-link to="/">Home</router-link></li>
                                            <li class="text-white active">Network Protection</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- BradCrumb header End -->
        <!-- Start Content -->
        <section class="section">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <h2>The Foundation of Your Operational Security</h2>
                        <p>For any critical operation, the network is the central nervous system. It carries your financial data, operational commands, and security footage. Our Network Protection services are designed to safeguard this critical asset, reduce your attack surface, and ensure reliable performance. We go beyond simple internet setups to build resilient, secure, and manageable networks for demanding business environments in Laredo and South Texas.</p>
                        
                        <h2>Our Network Protection Services</h2>
                        
                        <h3>Business-Grade Firewall Deployment</h3>
                        <p>We design and deploy enterprise-grade firewalls to serve as the secure gateway for your network. Our process includes:</p>
                        <ul>
                            <li>Assessing your specific operational needs, data flows, and risk factors.</li>
                            <li>Creating and enforcing strong access rules, application control, and threat prevention policies.</li>
                            <li>Configuring secure site-to-site VPNs to link multiple locations and remote access for authorized staff.</li>
                        </ul>

                        <h3>Network Segmentation</h3>
                        <p>A flat network is a high-risk network. We implement segmentation to create secure, isolated zones within your infrastructure. This is critical for:</p>
                        <ul>
                            <li><strong>Isolating Critical Systems:</strong> Separating sensitive SCADA, OT, or POS systems from the general corporate network to prevent lateral movement by attackers.</li>
                            <li><strong>Securing User & Device Groups:</strong> Creating separate network segments for corporate users, contractors, and guest Wi-Fi to limit access and contain threats.</li>
                            <li><strong>Improving Performance:</strong> Reducing network congestion and improving performance for critical applications.</li>
                        </ul>

                        <h2>Real-World Scenario: Securing a Multi-Site Logistics Company</h2>
                        <p>A transportation company with yards in Laredo and Cotulla was using consumer-grade equipment, leading to frequent outages and security concerns. They needed to share data between sites and provide secure access for dispatchers working remotely.</p>
                        <p><strong>Our Solution:</strong> We deployed business-grade firewalls at both locations, establishing a permanent, encrypted site-to-site VPN tunnel. We segmented their network to separate office administration, dispatch systems, and guest access. The result was a dramatic increase in uptime, faster performance for their logistics software, and the elimination of security vulnerabilities.</p>
                        
                        <router-link to="/service-area">Learn how we support other multi-site operations in our Service Area.</router-link>
                    </div>
                </div>
            </div>
        </section>
        <!-- End Content -->
    </div>
</template>
<script>
    export default {
        name: 'NetworkProtection'
    }
</script>
